module.exports = __webpack_public_path__ + "assets/img/1.f8126f4f.png";